import AntdMenu                       from 'antd/lib/menu';
import { MenuProps as AntdMenuProps } from 'antd/lib/menu';

export type MenuProps = AntdMenuProps;

const Menu = (props: MenuProps) => {

	return (
		<AntdMenu
			{...props}
		/>
	);
};

export default Menu;
